import makeContextStore, { Action } from '@/hooks/makeContextStore';

export enum PositionActionTypes {
  SET_CHIP_STACK_POSITION = 'SET_CHIP_STACK_POSITION',
  SET_POT_POSITION = 'SET_POT_POSITION',
  SET_USER_CHIP_REF = 'SET_USER_CHIP_REF',
  SET_POT_REF = 'SET_POT_REF',
}

export interface PositionState {
  tableRef: React.RefObject<HTMLDivElement> | null;
  userChipsPositions: Record<number, { x: number; y: number }>;
  potPosition: { x: number; y: number };
  potRef: React.RefObject<HTMLDivElement> | null;
  userChipsRefs: Record<number, React.RefObject<HTMLDivElement>>;
}

export type PositionAction = Action<PositionActionTypes>;

const initialState: PositionState = {
  tableRef: null,
  potRef: null,
  userChipsRefs: {},
  userChipsPositions: {},
  potPosition: { x: 0, y: 0 },
};

const positionReducer = (state: PositionState, action: PositionAction) => {
  switch (action.type) {
    case PositionActionTypes.SET_CHIP_STACK_POSITION:
      console.log('SET_CHIP_STACK_POSITION', action.payload);
      return {
        ...state,
        userChipsPositions: {
          ...state.userChipsPositions,
          [action.payload.seatNumber]: action.payload.position,
        },
      };
    case PositionActionTypes.SET_POT_POSITION:
      console.log('SET_POT_POSITION', action.payload);
      return { ...state, potPosition: action.payload };
    case PositionActionTypes.SET_USER_CHIP_REF:
      return {
        ...state,
        userChipsRefs: {
          ...state.userChipsRefs,
          [action.payload.seatNumber]: action.payload.ref,
        },
      };
    case PositionActionTypes.SET_POT_REF:
      return { ...state, potRef: action.payload };
    default:
      return state;
  }
};

const [PositionProvider, usePositionStore, usePositionDispatch, PositionContext] = makeContextStore<
  PositionActionTypes,
  PositionState
>('Position', positionReducer, initialState);

export { PositionProvider, usePositionStore, usePositionDispatch, PositionContext };
